import { shallowEqual } from "react-redux";

import { useAppSelector } from "@/providers/store/hooks";

import { DEFAULT_MAP_STYLE } from "../constants";
import { useMapStyle } from "../contexts/map-style-context";
import { getMapVisualThemeByStyle } from "../map-visual-theme.config";

import type { MapStyle } from "../enums/map-style.enum";

export function useCurrentMapVisualTheme(districtId?: string | null) {
  const reduxDistrictId = useAppSelector((s) => s.district.selectedDistrict?.id ?? null, shallowEqual);
  const { mapStyle } = useMapStyle();

  const resolvedDistrictId = districtId ?? reduxDistrictId;
  const style: MapStyle =
    resolvedDistrictId != null ? (mapStyle[resolvedDistrictId] ?? DEFAULT_MAP_STYLE) : DEFAULT_MAP_STYLE;

  return getMapVisualThemeByStyle(style);
}
